module.exports = __webpack_public_path__ + "static/media/icon_mail.7eb89fe8.svg";